import * as React from "react";
import Checkbox from "../../CheckboxNew";
import Input from "../../Input-new/Input";
import { isFieldLocked } from "../../../access-levels";

const PropertyFinancials = ({data, handleChangeInput, openFinancialsSpreadsheet, viewMode, deleted, isFinancing, locks}) => {

    const parsePrecision = (value)=>{
        return Math.round(value*100)/100;
    }
    const getCalculatedData = () =>{
        const _units = data.UNITS || 1;
        const _occupancy = data.VACANCY || 100;
        if(data.NET_OPERATING_INCOME && data.CATEGORY=='apartments'){
            const rent = parseFloat(data.NET_OPERATING_INCOME.replace(/,/g, ''));
            const result = (rent / (_units * (_occupancy/100)))
            return result ? parsePrecision(result) : result;
        }
        return data.RENT_PER_SQFT ? parsePrecision(data.RENT_PER_SQFT) : data.RENT_PER_SQFT;
    }
    let PRICE_PER_UNIT = data.LIST_PRICE != null && data.UNITS != null ? parseFloat(data.LIST_PRICE.replace(/,/g, '')) / (data.UNITS != null && data.UNITS > 0 ? data.UNITS : 1) : '';
    if(PRICE_PER_UNIT){
        PRICE_PER_UNIT = parsePrecision(PRICE_PER_UNIT);
    }
    return (
        <div className="Property-financials">
            {
                !isFinancing &&
                <div className="Property-financials_actions">
                    <button type='button'
                            className="button-new positive"
                            onClick={openFinancialsSpreadsheet}
                    >
                        View Financials
                    </button>
                    <Checkbox
                        text="HIDE FINANCIALS"
                        type={viewMode || isFieldLocked(locks, "HIDE_FINANCIALS") ? "uncheckable" : "checkable"}
                        isSelected={data.HIDE_FINANCIALS}
                        handleClick={handleChangeInput}
                        name="HIDE_FINANCIALS"
                    />
                    {data.TYPE === 'MT' &&
                        <Checkbox
                            text="PROFORMA"
                            type={viewMode || isFieldLocked(locks, "IS_PROFORMA_PRICING") ? "uncheckable" : "checkable"}
                            isSelected={data.IS_PROFORMA_PRICING}
                            handleClick={handleChangeInput}
                            name="IS_PROFORMA_PRICING"
                        />
                    }
                </div>
            }
            <div className="Property-financials_column">
                {
                    isFinancing ?
                        <Input
                            className="Property-financials_column_item"
                            type="text"
                            valueType="integer"
                            name="HSC_PRICE"
                            label="Price"
                            value={data.HSC_PRICE}
                            disabled={isFieldLocked(locks, "HSC_PRICE")}
                            handleParentChange={handleChangeInput}
                            viewMode={viewMode}
                            deleted={deleted}
                            isDollar
                        />
                        :
                        <Input
                            className="Property-financials_column_item"
                            type="text"
                            valueType="integer"
                            name="LIST_PRICE"
                            label={"List Price"}
                            value={data.LIST_PRICE}
                            disabled={isFieldLocked(locks, "LIST_PRICE")}
                            handleParentChange={handleChangeInput}
                            viewMode={viewMode}
                            deleted={deleted}
                            isDollar
                        />
                }
                <Input
                    className="Property-financials_column_item"
                    type="text"
                    valueType="percent"
                    name={data.IS_PROFORMA_PRICING ? "PROFORMA_CAP_RATE" : "CAPITALIZATION_RATE"}
                    label={data.IS_PROFORMA_PRICING ? "Proforma Cap Rate" : "Cap Rate"}
                    value={ data.IS_PROFORMA_PRICING ? data.PROFORMA_CAP_RATE : data.CAPITALIZATION_RATE}
                    disabled={data.IS_PROFORMA_PRICING || isFieldLocked(locks, "CAPITALIZATION_RATE")}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                <Input
                    className="Property-financials_column_item"
                    type="text"
                    valueType="integer"
                    name={data.IS_PROFORMA_PRICING ? "PROFORMA_NOI" : "NET_OPERATING_INCOME"}
                    label={data.IS_PROFORMA_PRICING ? "Proforma NOI" : "NOI"}
                    value={data.IS_PROFORMA_PRICING ? data.PROFORMA_NOI : data.NET_OPERATING_INCOME}
                    disabled={data.IS_PROFORMA_PRICING || isFieldLocked(locks, "NET_OPERATING_INCOME")}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                    isDollar
                />
                {
                    data.TYPE === 'MT' &&
                    <Input
                        className="Property-financials_column_item"
                        type="text"
                        valueType="integer"
                        name={data.IS_PROFORMA_PRICING ? "PROFORMA_BASE_RENT" : "BASE_RENT"}
                        label={data.IS_PROFORMA_PRICING ? "Proforma Base Rent" : "Base Rent"}
                        value={data.IS_PROFORMA_PRICING ? data.PROFORMA_BASE_RENT : data.BASE_RENT}
                        disabled={data.IS_PROFORMA_PRICING || isFieldLocked(locks, "BASE_RENT")}
                        handleParentChange={handleChangeInput}
                        viewMode={viewMode}
                        deleted={deleted}
                        isDollar
                    />
                }
                {data.CATEGORY=='apartments' ?
                    <Input
                    className="Property-financials_column_item"
                    valueType="integer"
                    name="UNITS"
                    label="# of UNITS"
                    value={data.UNITS}
                    disabled={isFieldLocked(locks, "UNITS")}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                : null }
            </div>
            <div className="Property-financials_column">
                <Input
                    className="Property-financials_column_item"
                    type="text"
                    valueType="float"
                    name="PRICE_PER_SQFT"
                    label="PSF – auto"
                    value={data.PRICE_PER_SQFT}
                    disabled
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                    decimals={2}
                    isDollar
                />
                {
                    (data.TYPE === 'MT' || data.CATEGORY == 'apartments')  &&
                    <Input
                        className="Property-financials_column_item"
                        type="text"
                        valueType="percent"
                        name="VACANCY"
                        label="Occupancy"
                        value={data.VACANCY}
                        disabled={isFieldLocked(locks, "VACANCY")}
                        handleParentChange={handleChangeInput}
                        viewMode={viewMode}
                        deleted={deleted}
                        decimals={2}
                    />
                }
                <Input
                    className="Property-financials_column_item"
                    type="text"
                    valueType="float"
                    name="RENT_PER_SQFT"
                    label={data.CATEGORY=='apartments' ? "Rent/Unit – auto" : "Rent/Sq Ft – auto"}
                    value={getCalculatedData()}
                    disabled
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                    decimals={2}
                    isDollar
                />
                { data.CATEGORY=='apartments' ?
                    <Input
                    className="Property-financials_column_item"
                    type="text"
                    valueType="float"
                    name="PRICE_PER_UNIT"
                    label="Price/Unit – auto"
                    value={PRICE_PER_UNIT}
                    disabled
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                    decimals={2}
                    isDollar
                /> 
                : null    
                }          
            </div>
        </div>
    );
};

export default PropertyFinancials;
